/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import * as R from 'ramda';
import { useQuery } from '@apollo/client';
import GetSouscriptionRecapQuery from '../graphql/queries/GetSouscriptionRecapQuery.js';

const useGetSouscriptionRecapQuery = (args) => {
  const { data, error, loading, refetch } = useQuery(GetSouscriptionRecapQuery, args);

  return {
    error,
    loading,
    refetch,
    getSouscriptionRecap: R.omit(['__typename'], data?.getSouscriptionRecap_souscription_recap || {})
  };
};

export default useGetSouscriptionRecapQuery;
